export const OnrampApiLoadErrorEvent = 'onramp_api.load_error';

type OnrampApiApplePaySetupSuccess = {
  eventName: 'onramp_api.apple_pay_setup_success';
};

type OnrampApiLoadPending = {
  eventName: 'onramp_api.load_pending';
};

type OnrampApiLoadSucces = {
  eventName: 'onramp_api.load_success';
};

type OnrampApiLoadError = {
  eventName: 'onramp_api.load_error';
  data: {
    errorCode: string;
    errorMessage: string;
  };
};

type OnrampApiSessionError = {
  eventName: 'onramp_api.session_error';
  data: {
    errorCode: string;
    errorMessage: string;
  };
};

type OnrampApiApplePayButtonPressed = {
  eventName: 'onramp_api.apple_pay_button_pressed';
};

type OnrampApiPendingPaymentAuth = {
  eventName: 'onramp_api.pending_payment_auth';
};

type OnrampApiPaymentAuthorized = {
  eventName: 'onramp_api.payment_authorized';
};

type OnrampApiCommitStart = {
  eventName: 'onramp_api.commit_start';
};

type OnrampApiCommitSuccess = {
  eventName: 'onramp_api.commit_success';
};

type OnrampApiPollingStart = {
  eventName: 'onramp_api.polling_start';
};

type OnrampApiPollingSuccess = {
  eventName: 'onramp_api.polling_success';
};

type OnrampApiPollingError = {
  eventName: 'onramp_api.polling_error';
  data: {
    errorCode: string;
    errorMessage: string;
  };
};

type OnrampApiCommitError = {
  eventName: 'onramp_api.commit_error';
  data: {
    errorCode: string;
    errorMessage: string;
  };
};

type OnrampApiCancel = {
  eventName: 'onramp_api.cancel';
};

type ApiOnrampSpendEvent =
  | OnrampApiApplePaySetupSuccess
  | OnrampApiLoadPending
  | OnrampApiLoadSucces
  | OnrampApiLoadError
  | OnrampApiSessionError
  | OnrampApiApplePayButtonPressed
  | OnrampApiPendingPaymentAuth
  | OnrampApiPaymentAuthorized
  | OnrampApiCommitStart
  | OnrampApiCommitSuccess
  | OnrampApiCommitError
  | OnrampApiPollingStart
  | OnrampApiPollingSuccess
  | OnrampApiPollingError
  | OnrampApiCancel;

export function sendApiOnrampPostMessage(event: ApiOnrampSpendEvent) {
  // we will be sending postMessages to different webviews
  if (window?.FlutterChannel) {
    window.FlutterChannel.postMessage(JSON.stringify(event));
  }
  if (window?.ReactNativeWebView) {
    window?.ReactNativeWebView?.postMessage?.(JSON.stringify(event));
  }
  if (window?.webkit?.messageHandlers?.cbOnramp) {
    window.webkit.messageHandlers.cbOnramp.postMessage(JSON.stringify(event));
  }
  window?.parent?.postMessage?.(JSON.stringify(event), '*');
}
